









import { Vue, Component, Emit } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import ky from 'ky'

@Component({
  components: {
    qrDialog: () => import('@/components/common/qr/qrDialog.vue')
  }
})
export default class QrReader extends Vue {
  $store!: ExStore
  qrErrorMessage = ''

  @Emit('close')
  onClose() {
    return
  }

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get patientId() {
    return this.userInfo.id
  }

  async QRData($event: string) {
    try {
      await this.$api.dispensation.uploadQR({
        patientId: this.patientId,
        data: $event,
        regular: true
      })
      await this.$store.dispatch('dispensation/fetch', {
        patientId: this.patientId
      })
      this.onClose()
    } catch (e) {
      if (e instanceof ky.HTTPError) {
        if (e.response.status !== 400) {
          this.qrErrorMessage = '不正なQRコードです'
          return
        }
        const errors = await e.response.json()
        const errorList = Object.keys(errors).reduce(
          (list, key) => list.concat(errors[key]),
          [] as string[]
        )
        this.qrErrorMessage = errorList.join(', ')
        return
      } else {
        this.qrErrorMessage = '通信エラー'
      }
      console.error(e)
    }
  }
}
